import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-brand-muted font-body text-sm tracking-widest uppercase animate-pulse">
          Authenticating…
        </div>
      </div>
    )
  }

  return user ? children : <Navigate to="/login" replace />
}
